import { Attributes, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';
import ContactDetail from './ContactDetail';

export default class Contact extends TemporalEntity {
    static typeName = "Contact";

    constructor() {
        super();
        this.makeObservable();
    }

    public contactId: number = 0;

    @Attributes.ChildObject(ContactDetail, true)
    public values: ContactDetail = new ContactDetail();

    @Rules.StringLength(200)
    public postalAddress: string = "";

    @Rules.StringLength(200)
    public physicalAddress: string = "";

    @Attributes.Nullable()
    public contactTypeId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New contact";
        } else {
            return "Contact";
        }
    }
}